import { Breakpoint, ThemeColor } from '@/enums'
import { themeBreakpointDown, themeColor, toThemePixels } from '@/utils'
import styled, { keyframes } from 'styled-components'
import { ifProp } from 'styled-tools'

const showTooltip = keyframes`
  from {
    opacity:0
  }
`

export const Container = styled.div`
  position: relative;
  width: fit-content;
  min-width: 0;
  overflow: hidden;
`

export const HoverContent = styled.div<{ dark?: boolean }>`
  max-width: 250px;
  min-width: 200px;
  z-index: 10000;
  border-radius: ${toThemePixels(3)};
  padding: ${toThemePixels(3)};
  animation: ${showTooltip} 0.15s linear;
  border: 1px solid ${themeColor(ThemeColor.b30)};
  background-color: ${ifProp(
    'dark',
    themeColor(ThemeColor.info3),
    themeColor(ThemeColor.b0),
  )};
  box-shadow: 0px 6px 12px rgba(11, 44, 93, 0.12),
    0px 0px 12px rgba(11, 44, 93, 0.08);
  text-overflow: ellipsis;
  font-size: ${toThemePixels(3.5)};
  pointer-events: none;

  ${themeBreakpointDown(Breakpoint.sm)} {
    width: ${toThemePixels(80)};
  }
`
